/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientRespondAttendanceDto = {
    /**
     * Action to take on attendance
     */
    action: ClientRespondAttendanceDto.action;
    /**
     * Reason for rejecting attendance (required when action is reject)
     */
    rejectionReason?: string;
    /**
     * Additional details about the rejection
     */
    rejectionDetails?: string;
};
export namespace ClientRespondAttendanceDto {
    /**
     * Action to take on attendance
     */
    export enum action {
        ACCEPT = 'accept',
        REJECT = 'reject',
    }
}

